import {Component, Inject, OnInit,} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {AlertService, AuthenticationService, UserService,} from '../../_services/index';

import {User} from '../../_models/index';

import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

import {LoginHelper, Role} from '../../helpers';
import {DOCUMENT} from "@angular/common";
import * as moment from 'moment';
import {FormBuilder} from "@angular/forms";
import {AssessmentService} from "../../_services/assessment.service";
import {forkJoin} from "rxjs";

const defaultDialogConfig = new MatDialogConfig();

@Component({
    standalone: false,
  selector: "assessmentSummary-component",
  templateUrl: 'assessmentSummary.component.html',
  styleUrls: ['./assessmentSummary.component.scss'],
})

export class AssessmentSummaryComponent implements OnInit {
  api = window.location.origin;
  items: any[];
  assessmentId: number = null;
  rows: any[] = [];
  assessments = [];
  tenantName: string;
  answers: any[];
  token = LoginHelper.getFileToken();
  users: User[];
  columns = [
    {field: 'name', header: ''},
    {field: 'completionName', header: 'Form Identifier'},
    {field: 'completed', header: 'Completed'},
  ]

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public alertService: AlertService,
    public authenticationService: AuthenticationService,
    public userService: UserService,
    public dialog: MatDialog,
    @Inject(DOCUMENT) public document: any,
    public _formBuilder: FormBuilder,
    public assessmentService: AssessmentService) {
    /*this.departments[1] = 'HR';
    this.departments[2] = 'Sales';
    this.departments[3] = 'Marketing';
    this.departments[4] = 'IT';
    this.departments[5] = 'Audit';
    this.departments[6] = 'Client Srvice';
    this.departments[7] = 'Engineering';
    this.departments[8] = 'Operations';
    this.departments[9] = 'Field';
    this.departments[-1] = 'No Department';*/
  }


  ngOnInit() {
    this.tenantName = LoginHelper.getTenantName();
    let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    forkJoin(this.assessmentService.getAllAssessments(),
      this.assessmentService.getAssessmentResults(true),
      this.userService.getAllShort()
    )
      .subscribe(data => {
        this.assessments = data[0];
        this.answers = data[1];
        this.users = data[2].filter(u => (u.role & (Role.Training | Role.Vendor)) == 0 || this.assessments.find(a => (a.assessmentUsers || []).find(s => s.userId == u.userId)));
        this.answers.forEach(a => a.user = (this.users.find(u => a.userId === u.userId) || {department: 'No Department'}));
        this.answers.forEach(a => a.results = JSON.parse(a.answers));
        this.assessments.forEach(a => {
          const answers = this.answers.filter(z => z.assessmentId === a.id).sort((x, y) => x.user.department > y.user.department ? 1 : x.user.department < y.user.department ? -1 : x.user.fullName > y.user.fullName ? 1 : -1);
          if (answers.length) {
            this.rows.push({name: a.quizData.name, bold: true});
            let currentDepartment = null;
            let currentUser = null;
            answers.forEach(q => {
              if (q.user.department !== currentDepartment) {
                this.rows.push({name: q.user.department || 'No departament'});
                currentDepartment = q.user.department;
              }
              this.rows.push({
                name: q.user.fullName !== currentUser ? q.user.fullName : '',
                completionName: q.completionName,
                completed: moment(q.date).format('L hh:mm'),
                color: q.isFinished ? '#CBDFB8' : '#eab18b'
              });
              currentUser = q.user.fullName;
            });
          }
        });
      });
  }

  getFullName(userId) {
    const user = this.users.find(u => u.userId == userId);
    if (!user) return "";
    if (user.firstName != null
      || user.lastName != null) {
      return user.firstName + ' ' + user.lastName;
    }

    return user.emailAddress;
  }
}
